module.exports = __webpack_public_path__ + "img/x.87497b0f.svg";